import { CashAccount } from "./cash-account";
import { ChartOfAccount } from "./chart-of-account";
import { Product } from "./product";
import { SystemField } from "./system-field";

export class CashTransferDetail extends SystemField { 
    product_id?:string;
    cash_acc_id?:string;
    product_coa_id?:string;
    cash_acc_coa_id?:string;
    description?:string;
    amount?:number;
    cash_transfer_id?:string;
    detail_type?:string;

    //relationship fields
    cash_account?:CashAccount;
    chart_of_account?:ChartOfAccount;
    products?:Product;
}
